import {
  Arrow,
  CheckboxItem,
  Content,
  ItemIndicator,
  Portal,
  Root,
  Trigger,
} from '@radix-ui/react-dropdown-menu'
import { type ColumnFiltersState } from '@tanstack/react-table'
import { CheckIcon, Filter } from 'lucide-react'

export function DropdownMultiFilter<T> ({
  columnFilters,
  setColumnFilters,
  property,
  label,
  options,
  ariaLabel,
}: {
  columnFilters: ColumnFiltersState;
  setColumnFilters: (arg: ColumnFiltersState) => void;
  property: keyof T & string;
  label: string;
  options: { label: string; value: string }[];
  ariaLabel: string;
}) {
  const checkFilter = (filterableKey: string, value: string) => {
    return columnFilters.some((filter) => filter.id === filterableKey && (filter.value as string[]).includes(value))
  }

  const toggleFilter = (checked: boolean, filterableKey: string, value: string) => {
    let filterExistsForKey = false
    const updatedFilters = columnFilters.map((filter) => {
      if (filter.id === filterableKey) {
        filterExistsForKey = true
        if (checked) {
          if (!(filter.value as string[]).includes(value)) {
            return { id: filterableKey, value: [...(filter.value as string[]), value] }
          }
        } else {
          return { id: filterableKey, value: (filter.value as string[]).filter((v) => v !== value) }
        }
      }
      return filter
    })

    if (checked && !filterExistsForKey) {
      setColumnFilters([...updatedFilters, { id: filterableKey, value: [value] }])
    } else {
      setColumnFilters(updatedFilters)
    }
  }

  const selected = options.filter(({ value }) => {
    return checkFilter(property, value)
  }).map(({ label }) => (label)).join(', ')

  return (
    <Root>
      <Trigger asChild>
        <button aria-label={ariaLabel} className='input-default'>
          <div
            className={`flex items-center justify-between hover:cursor-pointer ${
              selected ? 'gray-900' : 'text-gray-400'
            }`}
          >
            {selected || label}
            <Filter size={16} className='text-gray-400' />
          </div>
        </button>
      </Trigger>

      <Portal>
        <Content className='DropdownMenuContent' sideOffset={5}>
          {options.map((option) => {
            return (
              <CheckboxItem
                key={option.value}
                className='DropdownMenuCheckboxItem'
                checked={checkFilter(property, option.value)}
                onCheckedChange={(checked) => toggleFilter(checked, property, option.value)}
              >
                <ItemIndicator className='DropdownMenuItemIndicator'>
                  <CheckIcon size={16} color='#6941C6' />
                </ItemIndicator>
                <span className='capitalize'>{option.label}</span>
              </CheckboxItem>
            )
          })}
          <Arrow className='DropdownMenuArrow' />
        </Content>
      </Portal>
    </Root>
  )
}
